import { observer } from "mobx-react"

import {
    CircularProgress,
    FormControl,
    FormHelperText,
    InputLabel,
    MenuItem,
    Select,
} from "@mui/material"
import { t } from "@lingui/macro"

import { contactv2_DynamicFieldOption } from "src/api"

interface IProps {
    options: contactv2_DynamicFieldOption[]
    selectedIndex: number
    onSelectionChange: (index: number) => void
    errorMessage?: string
    disabled?: boolean
    isLoading?: boolean
}

export const DynamicFieldKeyDropdown = observer((props: IProps) => {
    return (
        <FormControl style={{ breakInside: "avoid", width: "100%" }}>
            <InputLabel id="dynamic-field-key-label">
                {t`contact-form-forms-detail-modal.form-fields-settings-dynamic-field-key-dropdown.header`}
            </InputLabel>
            <Select
                data-testid="dynamic-field-key-dropdown"
                labelId="dynamic-field-key-label"
                id="dynamic-field-key"
                value={props.selectedIndex >= 0 ? props.selectedIndex : ""}
                label={t`contact-form-forms-detail-modal.form-fields-settings-dynamic-field-key-dropdown.header`}
                onChange={(event) =>
                    props.onSelectionChange(event.target.value as number)
                }
                error={Boolean(props.errorMessage)}
                disabled={props.disabled === true || props.isLoading === true}
                endAdornment={
                    props.isLoading === true ? (
                        <CircularProgress size={20} sx={{ marginRight: 2 }} />
                    ) : null
                }
            >
                {props.options.map((item, index) => (
                    <MenuItem value={index} key={index}>
                        {item.label}
                    </MenuItem>
                ))}
            </Select>
            {Boolean(props.errorMessage) && (
                <FormHelperText error={true}>
                    {props.errorMessage}
                </FormHelperText>
            )}
        </FormControl>
    )
})
